import * as React from "react";
import { useForm } from "react-hook-form";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import "./QueryTool.css";
// import dropdown_arrow from "./dropdown_arrow.svg";
// import { Chart, CategoryScale } from "chart.js/auto";
import FormGroup from "../../../components/bootstrap/forms/FormGroup";
import Input from "../../../components/bootstrap/forms/Input";
import Select from "../../../components/bootstrap/forms/Select";
// import ReactSelect from "react-select";
// import { Checkbox, FormControlLabel } from "@mui/material";
// import Breadcrumb from "../../../components/bootstrap/Breadcrumb";
import Button from "../../../components/bootstrap/Button";
import Card, { CardBody, CardFooter } from "../../../components/bootstrap/Card";
// import Checks from "../../../components/bootstrap/forms/Checks";
import { AgGridReact } from "ag-grid-react";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../../components/ToastComponent";
import { capitalizeAllLetter } from "../common-component/CapitalizeFirstLetter";
import ToastComponent from "../../../components/ToastComponent";
import { log } from "node:console";
import { useLocation } from "react-router-dom";

// Chart.register(CategoryScale);
interface QueryParamType {
  qpId: number;
  queryId: number;
  createUser: string;
  lable: string;
  fieldName: string;
  fieldType: string;
}
export default function QueryTool() {
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const vyu_service_url = process.env.REACT_APP_VYU_SERVICE_URL;
  const form = useForm<FormValues>();
  const { handleSubmit } = form;
  const [datasorces, setDatasorces] = React.useState<any>([]);
  const [queries, setQueries] = React.useState<any>([]);
  const [selectedTable, setSelectedTable] = React.useState<string>("");
  const [tableCols, setTableCols] = React.useState<string[]>([]);
  const [metaData, setMetaData] = React.useState<any>({});
  const [QPList, setQpList] = React.useState<QueryParamType[]>([
    {
      qpId: 0,
      queryId: 0,
      createUser: "User",
      lable: "",
      fieldName: "",
      fieldType: "",
    },
  ]);
  const [show, setShow] = React.useState(false);
  const [previewString, setPreviewString] = React.useState<string>("");

  const [qpCount, setQpCount] = React.useState(1);
  const [selectString, setSelectString] = React.useState<any>([]);

  const [formData, setFormData] = React.useState<FormValues>({
    name: "",
    selectString: "",
    fromString: "",
    whereString: "",
    tag: "",
    querytype: "",
    createUser: "",
    datasource: 0,
    parentQuery: 0,
  });

  const isStoredFunction = formData.querytype === "stored_function";
  const isShowDisabled =
    !formData.querytype ||
    !formData.datasource ||
    !formData.selectString ||
    !formData.fromString;
  type FormValues = {
    name: string;
    selectString: string;
    fromString: string;
    whereString: string;
    tag: string;
    querytype: string;
    createUser: string;
    datasource: any;
    parentQuery: any;
  };
  type QueryValues = {
    name: string;
    selectString: string;
    fromString: string;
    whereString: string;
    tags: string;
    querytype: string;
    createUser: string;
    datasourceId: any;
    parentQuery: any;
    queryParamList: any[];
  };
  let queryJson: QueryValues = {
    name: " ",
    selectString: " ",
    fromString: " ",
    whereString: " ",
    tags: " ",
    querytype: " ",
    createUser: "mg",
    datasourceId: 0,
    parentQuery: 0,
    queryParamList: [],
  };
  const [columns, setColumns]: any[] = React.useState<GridColDef[]>([
    // { field: "id", headerName: "ID", width: 70 },
    // { field: "firstName", headerName: "First name", width: 130 },
    // { field: "lastName", headerName: "Last name", width: 130 },
    // { field: "age", headerName: "Age", type: "number", width: 90 },
    // {
    // 	field: 'fullName',
    // 	headerName: 'Full name',
    // 	description: 'This column has a value getter and is not sortable.',
    // 	sortable: false,
    // 	width: 160,
    // 	valueGetter: (value: any, row: { firstName: any; lastName: any }) =>
    // 		`${row.firstName || ''} ${row.lastName || ''}`
    // }
  ]);

  const [rows, setRows] = React.useState<any[]>([
    // { id: 1, lastName: "Snow", firstName: "Jon", age: 35 },
    // { id: 2, lastName: "Lannister", firstName: "Cersei", age: 42 },
    // { id: 3, lastName: "Lannister", firstName: "Jaime", age: 45 },
    // { id: 4, lastName: "Stark", firstName: "Arya", age: 16 },
    // { id: 5, lastName: "Targaryen", firstName: "Daenerys", age: 22 },
    // { id: 6, lastName: "Melisandre", firstName: null, age: 150 },
    // { id: 7, lastName: "Clifford", firstName: "Ferrara", age: 44 },
    // { id: 8, lastName: "Frances", firstName: "Rossini", age: 36 },
    // { id: 9, lastName: "Roxie", firstName: "Harvey", age: 65 },
  ]);
  const [rowId, setRowId] = React.useState<string | number>("id");

  const location = useLocation();

  // Load form data on mount
  React.useEffect(() => {
    const savedFormData = localStorage.getItem("queryToolFormData");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }
    const savedQPList = localStorage.getItem("queryToolQPList");
    if (savedQPList) {
      setQpList(JSON.parse(savedQPList));
    }
  }, []);

  // Save form data on change
  React.useEffect(() => {
    localStorage.setItem("queryToolFormData", JSON.stringify(formData));
  }, [formData]);
  React.useEffect(() => {
    localStorage.setItem("queryToolQPList", JSON.stringify(QPList));
  }, [QPList]);

  // Clear localStorage if leaving Query Tool section
  React.useEffect(() => {
    return () => {
      // If the next path is not a Query Tool page, clear localStorage
      // Adjust the path check as per your routing structure
      if (!location.pathname.startsWith("/queryTool")) {
        localStorage.removeItem("queryToolFormData");
        localStorage.removeItem("queryToolQPList");
      }
    };
  }, [location.pathname]);

  const addQueryParamToQPList = () => {
    setQpCount((prev) => prev + 1);
    // console.log(qpCount);
    setQpList([
      {
        qpId: qpCount,
        queryId: 0,
        createUser: "User",
        lable: "",
        fieldName: "",
        fieldType: "",
      },
      ...QPList,
    ]);
    // console.log(QPList);
  };

  const onSubmit = () => {
    queryJson = {
      name: capitalizeAllLetter(formData.name),
      selectString: formData.selectString,
      fromString: formData.fromString,
      whereString: formData.whereString,
      tags: formData.tag,
      querytype: formData.querytype,
      createUser: "User",
      parentQuery:
        formData.parentQuery !== 0 ? { id: formData.parentQuery } : null,
      datasourceId: { id: formData.datasource },
      queryParamList: QPList,
    };
    makeApiCall(queryJson);
  };
  React.useEffect(() => {
    apiCallToFetchAllQueriesOfLoggedInUser();
    let tokenStr = localStorage.getItem("token");
    fetch(`${vyu_api_url}/datasource/getAllDatasource`, {
      headers: { Authorization: `Bearer ${tokenStr}` },
    })
      .then((response) => response.json())
      .then((data) => {
        // Ensure we're setting an array
        if (Array.isArray(data)) {
          setDatasorces(data);
        } else if (data && Array.isArray(data.obj)) {
          setDatasorces(data.obj);
        } else {
          console.warn("Unexpected datasource response format:", data);
          setDatasorces([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching datasources:", error);
        setDatasorces([]);
      });
  }, []);

  const apiCallToFetchAllQueriesOfLoggedInUser = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${vyu_api_url}/query/getAllQuery`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();

      setQueries(data.obj);
    } catch (e) {
      // console.log(e);
      setQueries([[]]);
    }
  };
  // const apiCallToGetTableandColumns = async (dsId: number) => {
  //   try {
  //     const token = localStorage.getItem("token");
  //     const response = await fetch(
  //       `${vyu_service_url}/getTableList?id=${dsId}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           Accept: "application/json, text/plain, */*",
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     const data = await response.json();

  //     setMetaData(data);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const makeApiCall = (queryJson: any) => {
    let tokenStr = localStorage.getItem("token");
    fetch(`${vyu_api_url}/query/create`, {
      headers: {
        Authorization: `Bearer ${tokenStr}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(queryJson),
    })
      .then((response) => response.json())
      .then((json) => {
        // console.log(json);
        if (
          json?.status === "FAILED" &&
          json.message === "Unknown queryType: "
        ) {
          // console.log(json.message);
          handleError("Enter all the required fields to Create Query");
          return;
        } else if (json?.status === "FAILED") {
          handleError(json.message || "Failed to create query.");
          return; // Stop execution if API fails
        }
        const list: QueryParamType[] = QPList.map(
          (item) =>
            (item = {
              ...item,
              ["queryId"]: json.obj.id,
              ["createUser"]: json.obj.createUser,
            })
        );
        list
          .filter((item) => item.lable != null && item.lable !== "")
          .forEach((queryParam) => {
            // console.log(queryParam);
            let tokenStr = localStorage.getItem("token");
            fetch(`${vyu_api_url}/queryParam/createQueryParam`, {
              headers: {
                Authorization: `Bearer ${tokenStr}`,
                Accept: "application/json, text/plain, */*",
                "Content-Type": "application/json",
              },
              method: "POST",
              body: JSON.stringify(queryParam),
            })
              .then((response) => response.json())
              .then((json) => {
                console.log(json);
              });
          });

        handleSuccess(
          `Created Query with id=${json.obj.id} and its Params successfully `
        );
        handleFullReset();
      })
      .catch((error) =>
        console.error("Error creating  Query or params:", error)
      );
  };
  const handleWarning = (message: string) => {
    showWarningToast(message);
  };
  const handleSuccess = (message: string) => {
    showSuccessToast(message);
  };
  const handleError = (message: string) => {
    showErrorToast(message);
  };
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    // Handle 'datasource' case
    if (name === "datasource") {
      // console.log("VALUE :", value);
      // apiCallToGetTableandColumns(value);
    }
    // Handle 'fromString' case
    if (name === "fromString") {
      setSelectedTable(value);
      const cols = metaData[value] || [];
      const colData = cols.map((col: string) => ({
        label: col,
        value: col,
      }));
      // console.log(colData);
      setTableCols(colData);
    }

    // If query type is stored_function, clear the relevant fields
    if (name === "querytype" && value === "stored_function") {
      // Clear fields when Query Type is 'stored_function'
      setFormData({
        ...formData,
        querytype: value,
        name: "",
        parentQuery: 0,
        selectString: "",
        fromString: "",
        whereString: "",
      });
      setSelectString([]); // Clear the select input too
    }
    // else if (name === "selectString") {
    //   // Use the logic from handleChangeSelect for the 'Select' field
    //   const slctString = value.map((str: any) => str.value).join(",");
    //   setSelectString(value); // Update select input value
    //   setFormData({
    //     ...formData,
    //     selectString: slctString, // Update formData with the selected values
    //   });
    // }
    else {
      // Handle other fields normally
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleChangeSelect = (e: any) => {
    setSelectString(e);
    // const slctString = e.map((str: any) => str.value).join(",");
    setFormData({
      ...formData,
      selectString: e,
    });
  };

  const handleReset = () => {
    setFormData({
      name: "",
      selectString: "",
      fromString: "",
      whereString: "",
      tag: "",
      querytype: "",
      createUser: "",
      datasource: 0,
      parentQuery: 0,
    });
    setQpList([
      {
        qpId: 0,
        queryId: 0,
        createUser: "User",
        lable: "",
        fieldName: "",
        fieldType: "",
      },
    ]);
    setShow(false);
  };
  const handleFullReset = () => {
    setFormData({
      name: "",
      selectString: "",
      fromString: "",
      whereString: "",
      tag: "",
      querytype: "",
      createUser: "",
      datasource: 0,
      parentQuery: 0,
    });
    setQpList([
      {
        qpId: 0,
        queryId: 0,
        createUser: "User",
        lable: "",
        fieldName: "",
        fieldType: "",
      },
    ]);
    setShow(false);
  };
  const handleRemoveItem = (qpId: number) => {
    if (QPList.length > 1) {
      setQpList(QPList.filter((item) => item.qpId !== qpId));
    } else {
      handleWarning("You must have at least one item in the list.");
    }
    // console.log("filtered", QPList);
  };
  const onChangeInput = (
    e: { target: { name: any; value: any } },
    queryParamId: number
  ) => {
    const { name, value } = e.target;
    const editData = QPList.map((item) =>
      item.qpId === queryParamId && name ? { ...item, [name]: value } : item
    );
    setQpList(editData);
  };
  function handlePreview(): any {
    setShow(!show);
    let tokenStr = localStorage.getItem("token");
    let datasourceId = formData.datasource;
    let sqlQuery = `SELECT ${formData.selectString} FROM ${formData.fromString} WHERE  ${formData.whereString};`;
    setPreviewString(sqlQuery.toLowerCase());
    if (
      formData.whereString === null ||
      formData.whereString === "" ||
      formData.whereString.trim() === ""
    ) {
      sqlQuery = `SELECT ${formData.selectString} FROM ${formData.fromString};`;
      setPreviewString(sqlQuery.toLowerCase());
    }
    if (formData.whereString.toLowerCase().startsWith("group by")) {
      sqlQuery = `SELECT ${formData.selectString} FROM ${formData.fromString} ${formData.whereString};`;
      setPreviewString(sqlQuery.toLowerCase());
    }
    if (show === false) {
      // console.log(sqlQuery);
      let encodedQuery = encodeURIComponent(sqlQuery);
      console.log("encodeurl", encodedQuery);
      const contextValue = "createQuery";
      fetch(
        `${vyu_service_url}/getPreview?datasourceId=${datasourceId}&sqlQuery=${encodedQuery}&context=${contextValue}`,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
          method: "GET",
        }
      )
        .then((response) => response.json())
        .then((json) => {
          let tempArr = json.obj;
          let cols: any[] = [];
          let columnElement = {
            field: "age",
            headerName: "Age",
            type: "number",
            width: 70,
            flex: 1,
          };

          if (json.status === "Failed" || json.status === "FAILED") {
            console.log("Response JSON in Preview:", json);
            handleError(json.message);
          } else {
            if (json.message === "Got 0 records from datasource") {
              handleError(json.message);
            } else {
              for (let key of Object.keys(tempArr[0])) {
                columnElement = {
                  field: key,
                  headerName: key.toUpperCase(),
                  type: typeof key,
                  width: 180,
                  flex: 1,
                };
                cols.push(columnElement);
              }
            }
          }
          setColumns(cols);
          setRows(tempArr);
          setRowId(columnElement.field);
        });
    }
  }

  const inputStyle =
    "form-control block w-full px-3 py-2 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded-md transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none";
  const selectStyle = "form-select " + inputStyle;
  const smallRadius = { borderRadius: "4px", borderColor: "#E0E0E0" };
  const inputBorderStyle = { borderColor: "#D0D5DD", borderRadius: "4px" };
  return (
    <div className="column">
      <div className="col-lg-12">
        <Card stretch style={{ borderRadius: "4px" }}>
          <CardBody>
            <div className="row">
              <div className="col-md-6 mb-4">
                <FormGroup label="Query Type">
                  <span style={{ color: "red", marginRight: 4 }}>*</span>
                  <Select
                    ariaLabel="Select"
                    // className="shadow-xl italic w-full h-10 appearance-auto"
                    // style={{ width: "100%", height: "50px" }}
                    style={smallRadius}
                    className={selectStyle}
                    id="querytype"
                    name="querytype"
                    value={formData.querytype}
                    onChange={handleChange}
                    placeholder="Select Query Type"
                  >
                    <option value="sql">SQL</option>
                    <option value="stored_function">Stored Function</option>
                    <option value="excel">Excel</option>
                  </Select>
                </FormGroup>
              </div>
              <div className="col-md-6 mb-4">
                <FormGroup label="Name">
                  <Input
                    id="name"
                    name="name"
                    placeholder="Enter name of the query"
                    value={formData.name}
                    onChange={handleChange}
                    disabled={isStoredFunction}
                    style={smallRadius}
                    className={inputStyle}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 mb-4">
                <FormGroup label="Data Source">
                  <span style={{ color: "red", marginRight: 4 }}>*</span>
                  <Select
                    ariaLabel="State"
                    placeholder="Select DataSource"
                    id="datasource"
                    name="datasource"
                    value={formData.datasource}
                    onChange={handleChange}
                    style={smallRadius}
                    className={selectStyle}
                  >
                    {datasorces.map(
                      (datasorce: { id: number; name: string }) => (
                        <option
                          className="italic"
                          key={datasorce.id}
                          value={datasorce.id}
                        >
                          {datasorce.name}
                        </option>
                      )
                    )}
                  </Select>
                </FormGroup>
              </div>
              <div className="col-md-6 mb-4">
                <FormGroup label="Parent Query">
                  <Select
                    ariaLabel="Select"
                    id="parentQuery"
                    name="parentQuery"
                    placeholder="Select Parent Query"
                    value={formData.parentQuery}
                    onChange={handleChange}
                    disabled={isStoredFunction}
                    style={smallRadius}
                    className={selectStyle}
                  >
                    {queries?.map((query: { id: number; name: string }) => (
                      <option
                        className="italic"
                        key={query.id}
                        value={query.id}
                      >
                        {query.name}
                      </option>
                    ))}
                  </Select>
                </FormGroup>
              </div>
            </div>
            <div className="col-12 mb-4">
              <FormGroup className="d-flex flex-column">
                <label
                  htmlFor="fromString"
                  style={{ color: "gray", fontWeight: "500" }}
                >
                  From
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </label>
                <textarea
                  aria-label="From"
                  className="shadow-xl italic w-full h-20 appearance-auto"
                  id="fromString"
                  name="fromString"
                  value={formData.fromString}
                  onChange={handleChange}
                  placeholder="Enter From (e.g., tableName)"
                  disabled={isStoredFunction}
                  style={inputBorderStyle}
                />
              </FormGroup>
            </div>

            <div className="col-12 mb-4">
              <FormGroup className="d-flex flex-column">
                <label
                  htmlFor="selectString"
                  style={{ color: "gray", fontWeight: "500" }}
                >
                  Select
                  <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                </label>
                <textarea
                  aria-label="Select"
                  className="shadow-xl italic w-full h-20 appearance-auto"
                  id="selectString"
                  name="selectString"
                  placeholder="Enter select columns Ex: column1,column2..."
                  value={formData.selectString}
                  onChange={handleChange}
                  disabled={isStoredFunction}
                  style={inputBorderStyle}
                />
              </FormGroup>
            </div>

            <div className="col-12 mb-4">
              <FormGroup label="Where" className="d-flex flex-column">
                <textarea
                  aria-label="Where"
                  className="shadow-xl italic w-full h-30 appearance-auto"
                  id="whereString"
                  name="whereString"
                  placeholder="Enter Where <condition> Ex: column1 > 12 AND column2 <= 13"
                  value={formData.whereString}
                  onChange={handleChange}
                  disabled={isStoredFunction}
                  style={inputBorderStyle}
                />
              </FormGroup>
            </div>
            <div className="col-12 mb-4">
              <FormGroup label="Tags" className="d-flex flex-column">
                <textarea
                  aria-label="tag"
                  className="shadow-xl italic w-full h-30 appearance-auto"
                  id="tag"
                  name="tag"
                  placeholder="Enter tags"
                  value={formData.tag}
                  onChange={handleChange}
                  disabled={isStoredFunction}
                  style={inputBorderStyle}
                />
              </FormGroup>
            </div>
            <div className="text-xl italic bg-slate-200  basis-1/2  border-black	border-1 rounded-lg">
              <h6
                className="font-semibold italic text-2xl pb-3 pt-3"
                // style={{ fontWeight: "bold" }}
              >
                Create Query-Params
              </h6>
              <table
                className="w-full border border-gray-400 border-2 rounded-lg border-collapse"
                style={{
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: "0",
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                <tbody>
                  <tr className="border-black">
                    <th className="text text-s italic bg-slate-200 rounded-tl-lg border-black  h-6">
                      LABLE
                    </th>
                    <th className="text text-xl italic bg-slate-200  basis-1/2  border-black h-11">
                      FIELD-NAME
                    </th>
                    <th className="text text-xl italic bg-slate-200 rounded-lg basis-1/2 h-11">
                      FIELD-TYPE
                    </th>
                    <td className="addButton text-md basis-1/2 border-black text">
                      <button
                        type="button"
                        className="btn btn-link text-primary p-0"
                        onClick={addQueryParamToQPList}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          fill="#0D57DE"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                  {QPList.map((item) => (
                    <tr
                      key={item.qpId}
                      className="shadow-xl italic bg-white w-full h-9"
                    >
                      <td className="text-md basis-1/2  border-black">
                        <div className="col-lg-12">
                          <Input
                            name="lable"
                            className="shadow-xl italic bg-white w-full h-11 text-center"
                            style={{
                              borderRadius: "0px",
                              borderColor: "#E0E0E0",
                            }}
                            value={item.lable}
                            type="text"
                            onChange={(e: any) => onChangeInput(e, item.qpId)}
                            placeholder="Enter Label..."
                          />
                        </div>
                      </td>
                      <td className="text-md basis-1/2 border-black">
                        <div className="col-lg-12">
                          <Input
                            className="shadow-xl italic bg-white w-full h-11 text-center"
                            style={{
                              borderRadius: "0px",
                              borderColor: "#E0E0E0",
                            }}
                            name="fieldName"
                            value={item.fieldName}
                            type="text"
                            onChange={(e: any) => onChangeInput(e, item.qpId)}
                            placeholder="Enter Field Name..."
                          />
                        </div>
                      </td>
                      <td className="text-md basis-1/2  border-black">
                        <div className="col-lg-12">
                          <Input
                            className="text-black shadow-xl italic bg-white w-full h-11 text-center"
                            style={{
                              borderRadius: "0px",
                              borderColor: "#E0E0E0",
                            }}
                            name="fieldType"
                            value={item.fieldType}
                            type="text"
                            onChange={(e: any) => onChangeInput(e, item.qpId)}
                            placeholder="Enter Field Type..."
                          />
                        </div>
                      </td>
                      <td className="removeButton text-md basis-1/2 border-black">
                        <button
                          className="btn btn-link text-danger p-0"
                          onClick={() => handleRemoveItem(item.qpId)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            fill="#EA4335"
                            viewBox="0 0 16 16"
                          >
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardBody>

          <CardFooter>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "8px",
              }}
            >
              <form onSubmit={handleSubmit(onSubmit)}>
                {" "}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "8px",
                    // border: "1px solid black",
                  }}
                >
                  {/* <CardHeader>
                    <div
                      className="flex items-center"
                      style={{ display: "flex" }}
                    >
                      <Checks
                        // checked={checked}
                        type="checkbox"
                        checked={show}
                        onChange={handlePreview}
                        aria-label="pr"
                        disabled={isShowDisabled}
                        className={
                          isShowDisabled
                            ? "disabled-checkbox"
                            : "enable-checkbox"
                        }
                      />
                      <CardTitle
                        style={{ marginLeft: "5px", fontSize: "16px" }}
                      >
                        Preview
                      </CardTitle>
                    </div>
                  </CardHeader> */}
                  <Button
                    isLight={true}
                    // color="primary"
                    // className="basis-1/2 m-3 text-black italic bg-violet-200  hover:bg-violet-100 font-medium rounded-lg text-sm px-5 py-2 dark:bg-violet-200 dark:hover:bg-violet-100"
                    className="reset-button"
                    style={{ border: "1px solid #d0d5dd" }}
                    type="button"
                    onClick={handlePreview}
                    isDisable={isShowDisabled}
                  >
                    <svg
                      width="17"
                      height="16"
                      viewBox="0 0 17 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.116 16C1.67133 16 1.291 15.8417 0.975 15.525C0.659 15.2083 0.500667 14.8287 0.5 14.386V1.615C0.5 1.171 0.658333 0.791 0.975 0.475C1.29167 0.159 1.67167 0.000666667 2.115 0H14.885C15.329 0 15.709 0.158333 16.025 0.475C16.341 0.791667 16.4993 1.17167 16.5 1.615V14.385C16.5 14.829 16.3417 15.209 16.025 15.525C15.7083 15.841 15.3283 15.9993 14.885 16H2.116ZM2.116 15H14.885C15.0643 15 15.2117 14.9423 15.327 14.827C15.4423 14.7117 15.5 14.5643 15.5 14.385V3H1.5V14.385C1.5 14.5643 1.55767 14.7117 1.673 14.827C1.78833 14.9423 1.936 15 2.116 15ZM8.5 12C7.41533 12 6.438 11.722 5.568 11.166C4.698 10.6107 4.04067 9.88867 3.596 9C4.04067 8.11133 4.698 7.38933 5.568 6.834C6.438 6.278 7.41533 6 8.5 6C9.58467 6 10.562 6.278 11.432 6.834C12.302 7.39 12.9593 8.112 13.404 9C12.9593 9.88867 12.302 10.6107 11.432 11.166C10.562 11.722 9.58467 12 8.5 12ZM8.496 10.116C8.18467 10.116 7.92133 10.007 7.706 9.789C7.492 9.571 7.385 9.30667 7.385 8.996C7.385 8.68467 7.49367 8.42133 7.711 8.206C7.929 7.992 8.19333 7.885 8.504 7.885C8.81533 7.885 9.07867 7.99367 9.294 8.211C9.50867 8.429 9.616 8.69333 9.616 9.004C9.616 9.31533 9.507 9.57867 9.289 9.794C9.071 10.0087 8.80667 10.116 8.496 10.116ZM8.5 10.885C9.02 10.885 9.46433 10.701 9.833 10.333C10.2017 9.965 10.3857 9.52067 10.385 9C10.3843 8.47933 10.2003 8.035 9.833 7.667C9.465 7.299 9.02067 7.115 8.5 7.115C7.97933 7.115 7.535 7.299 7.167 7.667C6.799 8.035 6.615 8.47933 6.615 9C6.615 9.52067 6.799 9.965 7.167 10.333C7.535 10.701 7.97933 10.885 8.5 10.885Z"
                        fill="#0D57DE"
                      />
                    </svg>
                    <span style={{ fontSize: "12px" }}>Preview</span>
                  </Button>
                  <Button
                    isLight={true}
                    // color="primary"
                    // className="basis-1/2 m-3 text-black italic bg-violet-200  hover:bg-violet-100 font-medium rounded-lg text-sm px-5 py-2 dark:bg-violet-200 dark:hover:bg-violet-100"
                    className="reset-button"
                    style={{ border: "1px solid #d0d5dd" }}
                    type="button"
                    onClick={handleReset}
                  >
                    <span style={{ fontSize: "12px" }}>Reset</span>
                  </Button>
                  <Button
                    type="submit"
                    isLight={true}
                    color="primary"
                    style={{ border: "1px solid #d0d5dd" }}
                    className="signin-button"
                    isDisable={isShowDisabled}
                  >
                    <span style={{ fontSize: "12px" }}>Submit</span>
                  </Button>
                </div>
              </form>
            </div>
          </CardFooter>
        </Card>
      </div>
      <div className="col-lg-12">
        <Card stretch style={{ borderRadius: "4px" }}>
          <CardBody>
            {show && (
              <div className="items-center flex flex-col">
                <div className="justify-center text-blue-600 text-left">
                  <h5 style={{ color: "blue" }}>{previewString}</h5>
                </div>

                <div
                  className="flex items-center justify-center"
                  style={{ width: "100%", height: 450, flex: 1 }}
                >
                  <AgGridReact
                    className="ag-theme-quartz"
                    rowData={rows}
                    columnDefs={columns}
                    pagination={true}
                  />
                </div>
              </div>
            )}
          </CardBody>
        </Card>
        <ToastComponent />
      </div>
    </div>
  );
}
